// extracted by mini-css-extract-plugin
export default {"grid":"FNgTtb","container":"AxNTep"};